var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30518 11.9792C3.30518 10.1008 4.82788 8.57812 6.70622 8.57812H10.1073C11.9856 8.57812 13.5083 10.1008 13.5083 11.9792V11.9792C13.5083 12.9183 12.747 13.6797 11.8078 13.6797H5.0057C4.06653 13.6797 3.30518 12.9183 3.30518 11.9792V11.9792Z",
    fill: "#C1C7D4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.40674,
    cy: 4.8711,
    r: 2.55078,
    fill: "#C1C7D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMain);
export default __webpack_public_path__ + "static/media/profile-main.aedd26470c4856a1fdedfb7daea97651.svg";
export { ForwardRef as ReactComponent };